
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42 56H14a2 2 0 01-2-2V18a2 2 0 012-2h20l10 10v28a2 2 0 01-2 2z","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20 16v-6a2 2 0 012-2h20l10 10v28a2 2 0 01-2 2h-6","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22 38h12M22 46h12","stroke":"#56BFC7","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    